import { range } from 'lodash';
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const getDaySchedule = (day, index) => ({
  firstPeriod: {
    opening: '0800',
    closing: '1200',
  },
  secondPeriod: {
    opening: '1600',
    closing: '2000',
  },
  hasSecondPeriod: false,
  name: day,
  open: index === 0 || index === 6 ? false : true,
  number: index,
  order: index === 0 ? 6 : index - 1,
});

const getExactDaySchedule = (day, index) => ({
  firstPeriod: {
    opening: {
      hours: '08',
      minutes: '00',
    },
    closing: {
      hours: '12',
      minutes: '00',
    },
  },
  secondPeriod: {
    opening: {
      hours: '16',
      minutes: '00',
    },
    closing: {
      hours: '20',
      minutes: '00',
    },
  },
  hasSecondPeriod: false,
  name: day,
  open: index === 0 || index === 6 ? false : true,
  number: index,
  order: index === 0 ? 6 : index - 1,
});

const create = () => days.map(getDaySchedule);
const createExactDaySchedule = () => days.map(getExactDaySchedule);

const getHours = () => {
  const hours = [];
  for (let n = 0; n < 24; n++) {
    if (n > 9) {
      hours.push({ hour: `${n}00`, displayHour: `${n}:00` });
      hours.push({ hour: `${n}30`, displayHour: `${n}:30` });
    } else {
      hours.push({ hour: `0${n}00`, displayHour: `0${n}:00` });
      hours.push({ hour: `0${n}30`, displayHour: `0${n}:30` });
    }
  }
  hours.push({
    hour: '2359', displayHour: '23:59'
  });
  return hours;
};

const generateTime = (time, type) => {
  const defineType = type === 'hours' ? 'hour' : 'minute';
  const display = `display${defineType[0].toUpperCase()}${defineType.substr(1)}`;

  return range(0, time + 1).map(n => ({
    [defineType]: n.toString().padStart(2, '0'),
    [display]: n.toString().padStart(2, '0'),
  }));
};

const getHour = () => generateTime(23, 'hours');

const getMinutes = () => generateTime(59, 'minutes');

const scheduleFormat = (scheduleTimeTogether, schedulePreciseTime, separateHour = true) => {

  let newSchedule = [];

  if (separateHour) {
    newSchedule = schedulePreciseTime.map((schedule) => {
      const day = scheduleTimeTogether.find((d) => schedule.name === d.name);

      schedule.firstPeriod.opening.hours = day.firstPeriod.opening.substring(0, 2);
      schedule.firstPeriod.opening.minutes = day.firstPeriod.opening.substring(2);
      schedule.firstPeriod.closing.hours = day.firstPeriod.closing.substring(0, 2);
      schedule.firstPeriod.closing.minutes = day.firstPeriod.closing.substring(2);

      schedule.secondPeriod.opening.hours = day.secondPeriod.opening.substring(0, 2);
      schedule.secondPeriod.opening.minutes = day.secondPeriod.opening.substring(2);
      schedule.secondPeriod.closing.hours = day.secondPeriod.closing.substring(0, 2);
      schedule.secondPeriod.closing.minutes = day.secondPeriod.closing.substring(2);

      schedule.hasSecondPeriod = day.hasSecondPeriod;
      schedule.name = day.name;
      schedule.number = day.number;
      schedule.open = day.open;
      schedule.order = day.order;

      return schedule;
    });
  } else {
    newSchedule = scheduleTimeTogether.map((schedule) => {
      const day = schedulePreciseTime.find((d) => schedule.name === d.name);

      schedule.firstPeriod.opening = `${day.firstPeriod.opening.hours}${day.firstPeriod.opening.minutes}`;
      schedule.firstPeriod.closing = `${day.firstPeriod.closing.hours}${day.firstPeriod.closing.minutes}`;
      schedule.secondPeriod.opening = `${day.secondPeriod.opening.hours}${day.secondPeriod.opening.minutes}`;
      schedule.secondPeriod.closing = `${day.secondPeriod.closing.hours}${day.secondPeriod.closing.minutes}`;

      schedule.hasSecondPeriod = day.hasSecondPeriod;
      schedule.name = day.name;
      schedule.number = day.number;
      schedule.open = day.open;
      schedule.order = day.order;

      return schedule;
    });
  }
  return newSchedule;
};

const applyToAll = (data, schedule, separateHour = false) => {
  if (!separateHour) {
    schedule.forEach(day => {
      day.firstPeriod.opening = data.firstPeriod.opening;
      day.firstPeriod.closing = data.firstPeriod.closing;
      day.secondPeriod.opening = data.secondPeriod.opening;
      day.secondPeriod.closing = data.secondPeriod.closing;
      day.hasSecondPeriod = data.hasSecondPeriod;
    });
  } else {
    schedule.forEach((day) => {
      day.hasSecondPeriod = data.hasSecondPeriod;
      day.firstPeriod.opening.hours = data.firstPeriod.opening.hours;
      day.firstPeriod.opening.minutes = data.firstPeriod.opening.minutes;
      day.firstPeriod.closing.hours = data.firstPeriod.closing.hours;
      day.firstPeriod.closing.minutes = data.firstPeriod.closing.minutes;

      day.secondPeriod.opening.hours = data.secondPeriod.opening.hours;
      day.secondPeriod.opening.minutes = data.secondPeriod.opening.minutes;
      day.secondPeriod.closing.hours = data.secondPeriod.closing.hours;
      day.secondPeriod.closing.minutes = data.secondPeriod.closing.minutes;
    });
  }
};

const sort = schedule => days.map(day => {
  for (let i = schedule.length - 1; i >= 0; i--) {
    if (schedule[i].name === day) {
      return schedule[i];
    }
  }
});

const reOrder = schedule => {
  let firstElem = schedule.shift();
  schedule.push(firstElem);
  return schedule;
};

module.exports = {
  getDaySchedule,
  create,
  getHours,
  getHour,
  getMinutes,
  createExactDaySchedule,
  scheduleFormat,
  applyToAll,
  sort,
  reOrder,
};
